import { DirectiveOptions } from 'vue';
import url from 'url';
import { DirectiveBinding } from 'vue/types/options';
import { isUndef } from '@/lib/utils';

// todo: 当发生update时，需要将已有的setTimeout关闭
function tryLoad(el: HTMLElement, binding: DirectiveBinding) {
    if (el.tagName.toLowerCase() !== 'img') {
        return;
    }

    const src = el.getAttribute('src');
    if (!src) {
        return;
    }
    const result = url.parse(src, true);
    // @ts-ignore
    if (isUndef(el.__try_count)) {
        // @ts-ignore
        el.__try_count = 3;
    }

    // 加载失败
    el.onerror = (e) => {
        // @ts-ignore
        // @ts-ignore
        if (el.__try_count <= 0) {
            return;
        }
        // @ts-ignore
        el.__try_count--;

        setTimeout(() => {
            result.search = null;
            result.query.t = Math.random().toFixed(3);
            el.setAttribute('src', url.format(result));
        }, 1000);
    };
}

const tryImage: DirectiveOptions = {
    bind: tryLoad,
    update: tryLoad,
};

export default tryImage;
